import { render } from "./ServiceForm.vue?vue&type=template&id=37be62be&scoped=true"
import script from "./ServiceForm.vue?vue&type=script&lang=js"
export * from "./ServiceForm.vue?vue&type=script&lang=js"

import "./ServiceForm.vue?vue&type=style&index=0&id=37be62be&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37be62be"]])

export default __exports__